import React from "react";
import { Container } from "./style";
import ChatComp from "../../Containers/ChatContainer/DirectMessage";

const SideBar = ({ toggleSideBar, isChatOpen, isInstructor }) => {
  return (
    <Container toggleSideBar={toggleSideBar} isChatOPen={isChatOpen} isInstructor={isInstructor}>
      <ChatComp id={isChatOpen.course.id} title={isChatOpen.course.title} />
    </Container>
  );
};

export default SideBar;
